export enum ECustomerActivation {
    Verified = 'Verified',
    Unverified = 'Unverified',
    Pending = 'Pending',
}